export default function getResource(label, vars = []) {
    const resources = {
        productPrice: 'Price',
        fillSize: 'Fill Size',
        rating: 'Rating',
        ingredientHighlights: 'Ingredient Highlights',
        seeDetails: 'See Full Details',
        value: 'value',
        goodFor: 'Good For',
        targetedConcerns: 'Targets Concerns',
        skinValues: `${vars[0]} Skin`,
        hairValues: `${vars[0]} Hair`,
        highlyRated: 'Highly Rated By Customers For'
    };

    return resources[label];
}
